import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {CashReport} from "../model/cashReport";


@Component({
    selector: 'close-cash-report-dialog',
    templateUrl: './closeCashReportDialog.component.html',
    styleUrls: ['./closeCashReportDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class CloseCashReportDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    form: FormGroup;
    activeCashReport: CashReport;
    areCommentsRequired = false;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<CloseCashReportDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private _formBuilder: FormBuilder,
    ) {
        this.translationLoader.loadTranslations(polish);
        this.activeCashReport = this._data.activeCashReport;
        this.form = this.createForm();
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            endDayCash: [this.activeCashReport.cash, Validators.required],
            comments: [''],
        });
    }

    commentsRequired(): void {
        this.areCommentsRequired = this.activeCashReport.cash.toString() !== this.form.get('endDayCash').value.toString();
    }
}
